import { Table } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { KeyedRow } from '../../components/KeyedRow';
import { PageHeader } from '../../components/PageHeader';
import { Title } from '../../components/Title';
import { useFilter } from '../../hooks/useFilter';
import { usePagination } from '../../hooks/usePagination';
import { queryWithFilter } from '../../util/api/queryWithFilter';
import { queryWithFilterAndPages } from '../../util/api/queryWithFilterAndPages';
import { ProductTotalRow } from './components/ProductTotalsRow';
import type { ProductTotalDto } from './types/ProductTotalDto';

export function ProductTotals() {
	const { organisation } = useParams();

	const filter = useFilter();
	const pagination = usePagination();

	const productsQuery = queryWithFilterAndPages<ProductTotalDto[]>(
		`${organisation}/product-totals/all`,
		filter.value,
		pagination.value,
	);

	const productsCountQuery = queryWithFilter<number>(
		`${organisation}/product-totals/count`,
		filter.value,
	);

	return (
		<>
			<PageHeader title={'Product Totals'} filter={filter} />
			<DataTable
				pagination={pagination}
				totalItems={productsCountQuery.data?.value}
				isRowsLoading={productsQuery.isLoading}
				isPaginationLoading={productsCountQuery.isLoading}
				rows={pagination.value.pageSize}
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th>
							<Title label={'SKUID'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Branch'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Description'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Quantity Sold '} />
						</Table.Th>
						<Table.Th>
							<Title label={'Gross Sales'} />
						</Table.Th>
						<Table.Th>
							<Title label={'VAT'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Discount'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Individual Price'} />
						</Table.Th>
						<Table.Th>
							<Title label={'View'} />
						</Table.Th>
						<Table.Th />
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{productsQuery.data?.value.map((p) => (
						<ProductTotalRow originalProduct={p} />
					))}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
